import bookrec from "./assets/bookrec.jpg";
import explorefact from "./assets/explorefact.jpg";
import MDAF from "./assets/MDAF.jpg";
import Moive from "./assets/Movie.png";
import Employee from "./assets/Employee.png";
import Hotel from "./assets/Hotel_management_system.jpg";
import CentralLetter from "./assets/Central_letter_managemnt.jpg";
import Kanban from "./assets/Kanban_board.png";
import HR from "./assets/Hr_Management_system.png";
import KM from "./assets/KM_gateway.jpg";
const projects = [
    {
    id: 1,
    name: "Central Letter Management System",
    description: "A centralized system for managing university letters, documents, and correspondence efficiently.",
    image: CentralLetter,
    link: "https://centrallettermanagement.onrender.com/",
    sourceCodeLink: "",
    likes: 0,
    techStack: [
      { name: "Laravel", color: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300" },
      { name: "React", color: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300" },
      { name: "MySQL", color: "bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300" }
    ]
  },
  {
    id: 2,
    name: "HR Management System",
    description: "A human resources management system for employee records, attendance, and payroll.",
    image: HR,
    link: "https://hrmanagementsystem.onrender.com/",
    sourceCodeLink: "",
    likes: 0,
    techStack: [
      { name: "C#", color: "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300" },
      { name: ".NET", color: "bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-300" },
      { name: "SQL Server", color: "bg-teal-100 text-teal-800 dark:bg-teal-900 dark:text-teal-300" }
    ]
  },
  {
    id: 3,
    name: "MDAF Online Tutor Platform",
    description: "An online learning marketplace built with Laravel and React.",
    image: MDAF,
    link: "https://mdafonlinetutorplatform.onrender.com/#",
    sourceCodeLink: "https://github.com/MickeyDagm/MDAFOnlineTutor.git",
    likes: 0,
    techStack: [
      { name: "NodeJs", color: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300" },
      { name: "React", color: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300" },
      { name: "MongoDB", color: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300" }
    ]
  },
  {
    id: 4,
    name: "Movie Recommendation System",
    description: "Content-based movie recommender using React.",
    image: Moive,
    link: "https://movieandtrailersearchapp.netlify.app/",
    sourceCodeLink: "https://github.com/MickeyDagm/MovieSearchApp.git",
    likes: 0,
    techStack: [
      { name: "React", color: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300" },
      { name: "Tailwind", color: "bg-cyan-100 text-cyan-800 dark:bg-cyan-900 dark:text-cyan-300" }
    ]
  },
  {
    id: 5,
    name: "Book Recommendation System",
    description: "AI-based book recommendations using cosine similarity.",
    image: bookrec,
    link: "",
    sourceCodeLink: "https://github.com/MickeyDagm/Book-Recommendation",
    likes: 0,
    techStack: [
      { name: "Python", color: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300" },
      { name: "Pandas", color: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300" },
      { name: "NLP", color: "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300" }
    ]
  },
  {
    id: 6,
    name: "Employee Attrition Prediction",
    description: "Predict employee attrition using machine learning.",
    image: Employee,
    link: "",
    sourceCodeLink: "https://github.com/MickeyDagm/EmployeeAttritionSystem.git",
    likes: 0,
    techStack: [
      { name: "Python", color: "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300" },
      { name: "TensorFlow", color: "bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300" },
      { name: "Matplotlib", color: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300" }
    ]
  },
  {
    id: 7,
    name: "Hotel Management System",
    description: "A complete hotel booking and reservation system with price checking and room management.",
    image: Hotel,
    link: "https://hotelmanagementsystem101.netlify.app/",
    sourceCodeLink: "https://github.com/MickeyDagm/hotelManagementSystem.git",
    likes: 0,
    techStack: [
      { name: "React", color: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300" },
      { name: "Node.js", color: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300" },
      { name: "MongoDB", color: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900 dark:text-emerald-300" }
    ]
  },
  {
    id: 8,
    name: "Kanban Board",
    description: "A task organization board for managing workflows and tracking project progress.",
    image: Kanban,
    link: "https://boardkanbanfirst.netlify.app/",
    sourceCodeLink: "https://github.com/MickeyDagm/KanbanBoard.git",
    likes: 0,
    techStack: [
      { name: "React", color: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300" },
      { name: "TypeScript", color: "bg-indigo-100 text-indigo-800 dark:bg-indigo-900 dark:text-indigo-300" },
      { name: "Tailwind", color: "bg-cyan-100 text-cyan-800 dark:bg-cyan-900 dark:text-cyan-300" }
    ]
  },
    {
    id: 9,
    name: "Explore and Share Facts",
    description: "A facts-sharing site built with React and Supabase.",
    image: explorefact,
    link: "https://exploreandsharefact.netlify.app/",
    sourceCodeLink: "https://github.com/MickeyDagm/First-Website",
    likes: 0,
    techStack: [
      { name: "React", color: "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300" },
      { name: "Supabase", color: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300" },
      { name: "Tailwind", color: "bg-cyan-100 text-cyan-800 dark:bg-cyan-900 dark:text-cyan-300" }
    ]
  },
  {
    id: 10,
    name: "Knowledge Management System",
    description: "A centralized document management system for organizing and sharing knowledge across the organization.",
    image: KM,
    link: "https://unified-knowladge-gateway.onrender.com/",
    sourceCodeLink: "https://github.com/MickeyDagm/KM_Ethiotelecom.git",
    likes: 0,
    techStack: [
      { name: "Laravel", color: "bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-300" },
      { name: "Vue.js", color: "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300" },
      { name: "MySQL", color: "bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300" }
    ]
  }
];

export default projects;